import * as React from 'react'
import { Tag } from '@blueprintjs/core'
import { UprightStyle } from '../../../types'

interface Props {
  title: string
}

const s: UprightStyle = {
  tag: { margin: `0 3px 3px 0` }
}

const ProductTag: React.FC<Props> = ({ title }) => {
  return (
    <Tag minimal style={s.tag}>
      {title}
    </Tag>
  )
}
export default ProductTag
